/* global jQuery COMPONENTS google poiLocations locationProperty googleMapsStyler */

COMPONENTS.ComponentLocationsMap = (function ($) {
  function ComponentLocationsMap () {
    if (typeof poiLocations === 'undefined') {
      return
    }

    this.$component = $('[data-ecs-component="component-locationsmap"]')
    this.$map = $('[data-ecs-components-control="locations-map"]')
    this.mapElem = this.$map.get(0)
    this.$cardsGrid = $('[data-ecs-components-control="locations-cards"]')
    this.$locationCards = $('[data-ecs-components-control="location-card"]')
    this.$filterSelect = $('[data-ecs-components-poi-filter="select"]')
    this.$filterButtons = $('[data-ecs-components-poi-filter="button"]')
    this.$categoryAccordion = $('[data-ecs-components-control="locations-accordion"]')
    this.$resetButtons = this.$component.find('[data-ecs-components-poi-filter="reset"]')

    this.currentCategory = this.$map.data('ecs-components-locations')

    this.poiLocations = poiLocations

    this.map = null
    this.markers = []
    this.bounds = null

    this.mapArgs = {
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: false,
      cameraControl: true,
      streetViewControl: true,
      gestureHandling: 'cooperative'
    }

    if (typeof googleMapsStyler !== 'undefined') {
      this.mapArgs.styles = googleMapsStyler
    }
  }

  ComponentLocationsMap.prototype.init = function () {
    if (typeof poiLocations === 'undefined') {
      return
    }

    if (this.$component.length < 1 || this.$map.length < 1 || this.$locationCards.length < 1) {
      // the component or one of it's required elements is missing
      // bail out of the init to avoid JS crash
      return
    }

    if (this.$categoryAccordion.length >= 1) {
      this.bindAccordion()
    }
    this.initMap()
    this.bindFilter()
    this.bindCards()
    this.bindArrows()
    this.bindResetButtons()
  }

  ComponentLocationsMap.prototype.bindArrows = function () {
    const component = this
    $('[data-ecs-control="locations-arrow-previous"]').click(function () {
      component.$cardsGrid.animate({ scrollLeft: component.$cardsGrid.scrollLeft() - 250 })
    })
    $('[data-ecs-control="locations-arrow-next"]').click(function () {
      component.$cardsGrid.animate({ scrollLeft: component.$cardsGrid.scrollLeft() + 250 })
    })
  }

  ComponentLocationsMap.prototype.initMap = function () {
    this.map = new google.maps.Map(this.mapElem, this.mapArgs)
    this.addMarkers()
  }

  ComponentLocationsMap.prototype.bindFilter = function () {
    const component = this
    component.bindFilterSelect()
    component.bindFilterButtons()
  }

  ComponentLocationsMap.prototype.bindResetButtons = function () {
    const component = this
    component.$resetButtons.click(function() {
      component.currentCategory = 'all';

      component.$map.data('ecs-components-locations', component.currentCategory);

      // Reset the Semantic UI accordion to the first panel (or close all)
      if (component.$categoryAccordion.length) {
        component.$categoryAccordion.accordion('close others');
        component.$categoryAccordion.accordion('open', 0); // open first panel
        // Remove .active from all .title elements and add to reset button
        component.$categoryAccordion.find('.title').removeClass('active');
        $(this).addClass('active');
      }

      component.clearMarkers();
      component.addMarkers();

      component.$locationCards.each(function () {
        const $card = $(this);
        $card.show();
      });
    })
  }

  ComponentLocationsMap.prototype.bindAccordion = function () {
    const component = this
    this.$categoryAccordion.accordion({
      onChange: function () {
        component.currentCategory = $(this).data('ecs-locations-category')

        component.$map.data('ecs-components-locations', component.currentCategory)

        component.clearMarkers()
        component.addMarkers()

        component.$locationCards.each(function () {
          const $card = $(this)
          if (component.currentCategory === 'all') {
            $card.show()
          } else {
            if ($card.hasClass(component.currentCategory)) {
              $card.show()
            } else {
              $card.hide()
            }
          }
        })
        // Remove .active from reset button when any .title is clicked
        component.$resetButtons.removeClass('active');
      }
    })
  }

  ComponentLocationsMap.prototype.bindFilterSelect = function () {
    const component = this
    this.$filterSelect.change(function () {
      component.$map.data('ecs-components-locations', $(this).val())
      component.currentCategory = $(this).val()
      component.clearMarkers()
      component.addMarkers()

      component.$locationCards.each(function () {
        const $card = $(this)
        if (component.currentCategory === 'all') {
          $card.show()
        } else {
          if ($card.hasClass(component.currentCategory)) {
            $card.show()
          } else {
            $card.hide()
          }
        }
      })
    })
  }

  ComponentLocationsMap.prototype.bindFilterButtons = function () {
    const component = this
    component.$filterButtons.each(function () {
      const $button = $(this)

      $button.click(function () {
        component.$filterButtons.each(function () {
          $(this).removeClass('ecs_active')
          $(this).removeClass('components__active')
          $(this).removeClass('poi__active')
        })

        component.$map.data('ecs-components-locations', $($button).data('ecs-components-filter-val'))
        component.currentCategory = $($button).data('ecs-components-filter-val')
        component.clearMarkers()
        component.addMarkers()

        component.$locationCards.each(function () {
          const $card = $(this)
          if (component.currentCategory === 'all') {
            $card.show()
          } else {
            if ($card.hasClass(component.currentCategory)) {
              $card.show()
            } else {
              $card.hide()
            }
          }
        })

        $($button).addClass('ecs_active')
        $($button).addClass('components__active')
        $($button).addClass('poi__active')
      })
    })
  }

  ComponentLocationsMap.prototype.removeActive = function () {
    const component = this

    component.$locationCards.each(function () {
      $(this).removeClass('components__active')
      $(this).removeClass('poi__active')
    })
  }

  ComponentLocationsMap.prototype.bindCards = function () {
    const component = this

    this.$locationCards.each(function () {
      const $card = $(this)

      $card.click(function () {
        const id = $(this).data('ecs-components-location-id')
        component.removeActive()
        $card.addClass('components__active')
        $card.addClass('poi__active')
        component.clearMarkers()
        component.addMarkers(id)
      })
    })
  }

  ComponentLocationsMap.prototype.addMarkers = function (_highlightID = 0) {
    this.bounds = new google.maps.LatLngBounds()

    const locationsForCategory = this.poiLocations[this.currentCategory]

    for (let i = 0; i < locationsForCategory.length; i++) {
      const markerItem = {}
      const propertyLatLng = new google.maps.LatLng(locationsForCategory[i].lat, locationsForCategory[i].lng)
      markerItem.title = locationsForCategory[i].name
      markerItem.propertyLatLng = propertyLatLng
      markerItem.map = this.map
      markerItem.property = locationsForCategory[i].id
      markerItem.markerIcon = locationsForCategory[i].marker
      markerItem.markerId = i

      if (_highlightID === markerItem.property && locationsForCategory[i].marker_active !== false) {
        markerItem.markerIcon = locationsForCategory[i].marker_active
      }

      const marker = new google.maps.Marker({
        property: markerItem.property,
        position: markerItem.propertyLatLng,
        title: markerItem.title,
        icon: markerItem.markerIcon,
        map: markerItem.map,
        in_cat_id: markerItem.markerId
      })

      const contentString = `<div class="ecs__components__infowindow">
        <p class="ecs__component-locationsmap__card__name">
          ${markerItem.title}
        </p>
        <p class="ecs__component-locationsmap__card__address">
          ${locationsForCategory[i].addressbr}
        </p>
        <p class="ecs__component-locationsmap__card__link">
          <a href="${locationsForCategory[i].place_link}" target="_blank">View Location</a>
        </p>
      </div>`

      marker.infoWindow = new google.maps.InfoWindow({ content: contentString })

      this.bounds.extend(marker.position)
      this.markers.push(marker)
      this.bindMarker(marker)
    }

    for (let p = 0; p < locationProperty.length; p++) {
      const locationPropertyMarker = {}
      const propertyLatLng = new google.maps.LatLng(locationProperty[p].lat, locationProperty[p].lng)

      locationPropertyMarker.title = locationProperty[p].name
      locationPropertyMarker.propertyLatLng = propertyLatLng
      locationPropertyMarker.map = this.map
      locationPropertyMarker.property = locationProperty[p].id
      locationPropertyMarker.markerIcon = locationProperty[p].marker

      const propertyMarker = new google.maps.Marker({
        property: locationPropertyMarker.property,
        position: locationPropertyMarker.propertyLatLng,
        title: locationPropertyMarker.title,
        icon: locationPropertyMarker.markerIcon,
        map: locationPropertyMarker.map,
        optimized: false,
        zIndex: 99999999999,
        isProperty: true
      })

      const contentString = `<div class="ecs__components__infowindow ecs__components__infowindow__property">
        <p class="ecs__component-locationsmap__card__name">
          ${locationPropertyMarker.title}
        </p>
        <p class="ecs__component-locationsmap__card__address">
          ${locationProperty[p].addressbr}
        </p>
        <p class="ecs__component-locationsmap__card__link">
          <a href="${locationProperty[p].site_link}" target="_blank" aria-label="View the ${locationProperty[p].title} website">View Website</a>
        </p>
      </div>`

      propertyMarker.infoWindow = new google.maps.InfoWindow({ content: contentString })

      this.bounds.extend(propertyMarker.position)
      this.markers.push(propertyMarker)
      this.bindPropertyMarker(propertyMarker)
    }

    if (_highlightID > 0) {
      const highlight = this.markers.filter(function (marker) {
        return marker.property === _highlightID
      })

      this.map.setZoom(18)
      this.map.panTo(highlight[0].position)

      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].infoWindow) {
          this.markers[i].infoWindow.close()
        }

        // check if marker is a property marker
        if (!this.markers[i].isProperty) {
          // card click that sets regular marker
          this.markers[i].setIcon({
            url: locationsForCategory[1].marker,
          })
        }
      }

      highlight[0].infoWindow.open({
        anchor: highlight[0],
        map: this.map,
        shouldFocus: false
      })

      // card click that sets active marker
      highlight[0].setIcon({
        url: locationsForCategory[highlight[0].in_cat_id].marker_active,
      })
    } else {
      this.map.fitBounds(this.bounds)
    }
  }

  ComponentLocationsMap.prototype.bindMarker = function (_marker) {
    const component = this
    const selector = `[data-ecs-components-location-id="${_marker.property}"]`
    const $listItem = $(selector)
    const position = component.$cardsGrid.scrollLeft() - Math.abs($listItem.position().left)
    const locationsForCategory = this.poiLocations[this.currentCategory]

    google.maps.event.addListener(_marker, 'click', function () {
      // Only proceed if the card exists and is visible
      const listItemElement = $listItem.get(0);
      if (listItemElement && $listItem.is(':visible')) {
        listItemElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }

      component.$locationCards.each(function () {
        $(this).removeClass('poi__active')
        $(this).removeClass('components__active')
      });

      // Only add classes if the card exists and is visible
      if ($listItem.length && $listItem.is(':visible')) {
        $listItem.addClass('poi__active')
        $listItem.addClass('components__active')
      }

      // Defensive: check locationsForCategory is array and has expected indices
      if (Array.isArray(locationsForCategory) && locationsForCategory.length > 1 && locationsForCategory[1] && locationsForCategory[1].marker) {
        for (var i = 0; i < component.markers.length; i++) {
          if (component.markers[i].infoWindow) {
            component.markers[i].infoWindow.close()
          }
          // check if marker is a property marker
          if (!component.markers[i].isProperty) {
            component.markers[i].setIcon({
              url: locationsForCategory[1].marker,
            })
          }
        }
      } else {
        for (var i = 0; i < component.markers.length; i++) {
          if (component.markers[i].infoWindow) {
            component.markers[i].infoWindow.close()
          }
        }
      }

      _marker.infoWindow.open({
        anchor: _marker,
        map: component.map,
        shouldFocus: false
      })

      // check if marker is a property marker and marker_active exists
      if (!_marker.isProperty && Array.isArray(locationsForCategory) && locationsForCategory[0] && locationsForCategory[0].marker_active) {
        _marker.setIcon({
          url: locationsForCategory[0].marker_active,
        })
      }
    })
  }

  ComponentLocationsMap.prototype.bindPropertyMarker = function (_marker) {
    const component = this
    google.maps.event.addListener(_marker, 'click', function () {
      for (var i = 0; i < component.markers.length; i++) {
        if (component.markers[i].infoWindow) {
          component.markers[i].infoWindow.close()
        }
      }

      _marker.infoWindow.open({
        anchor: _marker,
        map: component.map,
        shouldFocus: false
      })
    })
  }

  ComponentLocationsMap.prototype.clearMarkers = function () {
    for (var m = 0; m < this.markers.length; m++) {
      this.markers[m].setMap(null)
    }
    this.markers = []
  }

  return ComponentLocationsMap
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentLocationsMap = new COMPONENTS.ComponentLocationsMap()
  COMPONENTS.componentLocationsMap.init()
})
